enum CategoryRoutes {
  CategoryList = '/content-settings/category',
  CategoryAdd = '/content-settings/category/add',
  CategoryEdit = '/content-settings/category/:id',
}

export default CategoryRoutes
